import { useState, useEffect } from 'react'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import PageLoaderUI from './page-loader-ui'

const PageLoader = () => {
	const { pageLoader } = useConfig()

	const [show, setShow] = useState(pageLoader?.enabled)

	useEffect(() => {
		if (pageLoader?.enabled) {
			setTimeout(() => {
				setShow(false)
			}, pageLoader?.timeout)
		}
	}, [pageLoader?.enabled, pageLoader?.timeout])

	return pageLoader?.enabled ? <PageLoaderUI show={show} /> : null
}

export default PageLoader
